import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';

import Loader from './components/Loader/Loader';
import AuthenticatedRoute from './helpers/AuthenticatedRoute';

const AsyncHome = Loadable({
  loader: () => import(/* webpackChunkName: "Home" */ './pages/Home/Home'),
  loading: Loader
});

export const AsyncExample = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Example" */ './pages/Example/Example'),
  loading: Loader
});

export const AsyncSignIn = Loadable({
  loader: () => import(/* webpackChunkName: "SignIn" */ './pages/Auth/SignIn'),
  loading: Loader
});

export const AsyncSignUp = Loadable({
  loader: () => import(/* webpackChunkName: "SignUp" */ './pages/Auth/SignUp'),
  loading: Loader
});

export const AsyncAccount = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Account" */ './pages/Auth/Account'),
  loading: Loader
});

export const AsyncResetPassword = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Reset Password" */ './pages/Auth/ResetPassword'
    ),
  loading: Loader
});

export const AsyncConfirmPasswordReset = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Confirm password reset" */ './pages/Auth/ConfirmPasswordReset'
    ),
  loading: Loader
});

const Routes = () => {
  return (
    <Switch>
      <Route path='/' exact component={AsyncHome} />
      <Route path='/example' exact component={AsyncExample} />
      <Route path='/sign_in' exact component={AsyncSignIn} />
      <Route path='/sign_up' exact component={AsyncSignUp} />
      <AuthenticatedRoute path='/account' exact component={AsyncAccount} />
      <Route
        path='/sign_in/reset_password'
        exact
        component={AsyncResetPassword}
      />
      <Route
        path='/sign_in/confirm_password_reset'
        exact
        component={AsyncConfirmPasswordReset}
      />
    </Switch>
  );
};

export default Routes;
